/* eslint-disable react/destructuring-assignment */
import React from "react";
import SpatialHome from "@iventis/plans/src/spatial-home";
import { IventisErrorBoundaryWithToast } from "@iventis/error-boundaries";
import { toast } from "@iventis/toasts/src/toast";
import PageWithAppBar from "./page-with-appbar";

export default (props: { match: { params: { libraryId?: string } } }) => (
    <PageWithAppBar>
        <IventisErrorBoundaryWithToast toast={toast}>
            <SpatialHome match={props.match} />
        </IventisErrorBoundaryWithToast>
    </PageWithAppBar>
);
